import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Slide, useMediaQuery, useTheme } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";

// Define the type for the transition component
interface TransitionPropsType extends TransitionProps {
  children: React.ReactElement<any, any>;
}

// Component for slide transition animation
const Transition = React.forwardRef(function Transition(props: TransitionPropsType, ref: React.Ref<unknown>) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface LoginDialogProps {
  open: boolean;
  onClose: () => void;
  handleSubmit: () => any;
}

// LoginDialog component to handle login confirmation and payment
const LoginDialog: React.FC<LoginDialogProps> = ({ open, handleSubmit, onClose }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      fullScreen={fullScreen}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 3,
          width: "100%",
          maxWidth: "420px",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
        },
      }}
    >
      <DialogTitle variant="h5" sx={{ textAlign: "center", fontWeight: "bold", mb: 2 }}>
        Sign In Required
      </DialogTitle>
      <DialogContent sx={{ textAlign: "center", mb: 3 }}>
        A valid MinRes staff or contractor sign-in is required. Without signing in, synchronization will be disabled, and only existing
        data will be accessible.{" "}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", gap: 2 }}>
        <Button onClick={onClose} color="secondary" variant="outlined" sx={{ px: 4 }}>
          Dismiss
        </Button>
        <Button type="submit" color="primary" variant="contained" onClick={handleSubmit} sx={{ px: 4 }}>
          Sign In
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LoginDialog;
